export default "__VITE_ASSET__3d0f089c__"